import React from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import { Toaster } from './components/ui/sonner';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import { InstallBanner, NotificationBanner, OfflineBanner } from './components/PWAComponents';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import SearchPage from './pages/SearchPage';
import CategoriesPage from './pages/CategoriesPage';
import ProfessionalDetailPage from './pages/ProfessionalDetailPage';
import ClientDashboard from './pages/ClientDashboard';
import ProDashboard from './pages/ProDashboard';
import InstallPage from './pages/InstallPage';

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="App min-h-screen bg-[#FAFAF9]">
          <BrowserRouter>
            <OfflineBanner />
            <NotificationBanner />
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/search" element={<SearchPage />} />
                <Route path="/categories" element={<CategoriesPage />} />
                <Route path="/professional/:id" element={<ProfessionalDetailPage />} />
                <Route path="/dashboard" element={<ClientDashboard />} />
                <Route path="/pro/dashboard" element={<ProDashboard />} />
                <Route path="/install" element={<InstallPage />} />
              </Routes>
            </main>
            <Footer />
            <InstallBanner />
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
